"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XHRDeviceUuidPlugin = void 0;
class XHRDeviceUuidPlugin {
    constructor(getDeviceUUID) {
        this.name = this.constructor.name;
        this.getDeviceUUID = getDeviceUUID;
    }
    async handleRequest(request) {
        const deviceUUID = await this.getDeviceUUID();
        request.headers = {
            ...request.headers,
            deviceUUID,
        };
        return Promise.resolve(request);
    }
}
exports.XHRDeviceUuidPlugin = XHRDeviceUuidPlugin;
//# sourceMappingURL=xhrDeviceUuidPlugin.js.map